import { useQuery } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../../../api/v1";
import { ApiResponse } from "../../../../../../types/api-response";
import axios from "../../../../../../utils/axiosInceptor";
import { Invoice } from "../../types";

const RECEIPT_INVOICE_COLUMNS = ["pdcId", "invoiceNumber", "description", "totalAmount", "balance", "dueDate"].join(
  ",",
);

type GetReceiptInvoicesParams = {
  leaseId?: string;
  tenantId?: string;
  status?: string;
};

const getReceiptInvoices = async (params: GetReceiptInvoicesParams) => {
  const url = `${apiV1Endpoint}/receipt/invoices`;
  const response = await axios.get<ApiResponse<Invoice[]>>(url, {
    params: {
      ...params,
      columns: RECEIPT_INVOICE_COLUMNS,
      status: params.status,
    },
  });

  return response.data.result;
};

type UseGetReceiptInvoicesOptions = GetReceiptInvoicesParams & {
  isEnabled?: boolean;
};

export const useGetReceiptInvoices = (options: UseGetReceiptInvoicesOptions) => {
  const { leaseId, tenantId, status = "pending", isEnabled = true } = options;

  const { data, isLoading } = useQuery({
    queryKey: ["receipt-invoices", leaseId, tenantId, status],
    queryFn: () => getReceiptInvoices({ leaseId, tenantId, status }),
    enabled: Boolean(leaseId && tenantId) && isEnabled,
    refetchOnWindowFocus: false,
  });

  return {
    invoices: data ?? [],
    isLoadingInvoices: isLoading,
  };
};
